import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { take } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { Filter } from '../../../core/components/filter-widget/filter.type';
import { PlatformService } from '../../../core/services/platform-service/platform.service';
import { RecommenderSectionDTO, RecommenderSectionState } from '../types/finder-recommender-dto.types';
import { FinderFilterMapper } from './finder-filter.mapper';

@Injectable({
  providedIn: 'root',
})
export class FinderService {
  private readonly finderEndpoint = environment.baseUrl + '/me/finder/sections';
  private finderSectionsState: RecommenderSectionState[] = [];

  constructor(
    private readonly http: HttpClient,
    private readonly platformService: PlatformService,
  ) {}

  public getFinderSections(search: string, filter: Filter) {
    return this.http
      .get<RecommenderSectionDTO[]>(this.finderEndpoint, { params: this.mapParams(search, filter) })
      .pipe(take(1));
  }

  public getFinderSection(sectionName: string, search: string, filter: Filter) {
    return this.http
      .get<RecommenderSectionDTO>(this.finderEndpoint + '/' + sectionName, {
        params: this.mapParams(search, filter),
      })
      .pipe(take(1));
  }

  private mapParams(search: string, filter: Filter) {
    let params = FinderFilterMapper.mapParams(search, filter);
    if (this.platformService.isMobile()) {
      params = params.append('filter', 'mobile:' + true);
    }
    return params;
  }

  /**
   * Updates the display state of recommender sections.
   * - When `showDetailSection` is provided, only the matching section
   *   will have `displayDetail` set to `true`.
   * - When `showDetailSection` is not provided, `displayDetail` will be
   *   set to `false` for all sections.
  */
  public updateRecommenderSectionsState(sections: RecommenderSectionDTO[], showDetailSection?: RecommenderSectionDTO):void {
    this.finderSectionsState = sections?.map(section => ({
      name: section.name,
      displayDetail: showDetailSection?.name === section.name
    }))
  }

  public clearRecommenderSectionsState(): void {
    this.finderSectionsState = [];
  }
}
